(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('applicationsCarrousel', ApplicationsCarrousel)

    /** @ngInject */
    function ApplicationsCarrousel($rootScope, HelperService, ApplicationService, AuthenticationService, PATHS, DATA_EVENTS) {
        function ApplicationsCarrouselController($scope) {
            const vm = this;

            vm.getApplicationImage = application => {
                return HelperService.imageResizePath('application', application.Id, application.Image, 200, 200);
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            init();

            function getApplications() {
                const selectedUnit = AuthenticationService.getSelectedUnit();

                HelperService.startLoading('.applications-carrousel');

                vm.isLoading = true;

                ApplicationService
                    .getHighlighted(selectedUnit.ExternalCode)
                    .then(success => {
                        vm.applications = success;
                        vm.isLoading = false;
                        HelperService.stopLoading('.applications-carrousel');
                    }, error => {
                        HelperService.errorCallback(error);
                    })
            }

            function init() {
                getApplications();

                vm.breakpoints = {
                    360: {
                        slidesPerView: 1,
                        spaceBetween: 5
                    },
                    400: {
                        slidesPerView: 2,
                        spaceBetween: 5
                    },
                    500: {
                        slidesPerView: 3,
                        spaceBetween: 5
                    },
                    800: {
                        slidesPerView: 3,
                        spaceBetween: 5
                    },
                    1000: {
                        slidesPerView: 4,
                        spaceBetween: 5
                    },
                    1200: {
                        slidesPerView: 6,
                        spaceBetween: 5
                    },
                    2000: {
                        slidesPerView: 6,
                        spaceBetween: 5
                    }
                }
            }
        }

        return {
            bindToController: true,
            controller: ApplicationsCarrouselController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/applications-carrousel/applications-carrousel.html`,
            scope: {}
        }
    }
}());